import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import Select from 'react-select';
import Toggle from 'react-toggle';
import getLocale from '../../../i18n/getLocale';

class DesignationsEditTab extends Component {
  constructor(props) {
    super(props);

    this.locale = getLocale();

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      id: this.props.designation_id,
      name: null,
      initials: null,
      type: null,
      priority: null,
      role: null,
      equip_chief: null,
      type_list: [
        {value: 1, label: 'Comum'},
        {value: 2, label: 'Instrutor'},
        {value: 3, label: 'Examinador'},
      ],
      role_list: [
        {value: 'captain', label: 'Comandante'},
        {value: 'copilot', label: 'Copiloto'},
        {value: 'flight_attendant', label: 'Comissário'},
      ],
    };

    //bind específico
    this.edit = this.edit.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(typeof newProps.designation_data.name !== 'undefined') {
      this.setState({
        id: newProps.designation_id,
        name: newProps.designation_data.name,
        initials: newProps.designation_data.initials,
        type: newProps.designation_data.type,
        priority: newProps.designation_data.priority,
        role: newProps.designation_data.role,
        equip_chief: newProps.designation_data.equip_chief,
      });
    }
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
      initials: this.state.initials,
      type: this.state.type,
      priority: this.state.priority,
      role: this.state.role,
      equip_chief: this.state.equip_chief,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/designacao', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <form onSubmit={this.edit}>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Designacoes.EditarDesignacao.tabDadosDaDesignacao.formulario.Nome}:</label>
          <input type="text" name="name" className="form-control" placeholder="" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Designacoes.EditarDesignacao.tabDadosDaDesignacao.formulario.Iniciais}:</label>
          <input type="text" name="initials" className="form-control" placeholder="" value={this.state.initials} onChange={this.handleChange.bind(this, 'initials')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Designacoes.EditarDesignacao.tabDadosDaDesignacao.formulario.Tipo}:</label>
          <Select
            className="form-field-name"
            name="type"
            value={this.state.type}
            searchable={true}
            placeholder={this.locale.Designacoes.EditarDesignacao.tabDadosDaDesignacao.formulario.placeholder.SelecionarTipo}
            onChange={this.handleSelectChange.bind(this, 'type')}
            options={this.state.type_list}
          />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Designacoes.EditarDesignacao.tabDadosDaDesignacao.formulario.Funcao}:</label>
          <Select
            className="form-field-name"
            name="role"
            value={this.state.role}
            searchable={true}
            placeholder={this.locale.Designacoes.EditarDesignacao.tabDadosDaDesignacao.formulario.placeholder.SelecionarFuncao}
            onChange={this.handleSelectChange.bind(this, 'role')}
            options={this.state.role_list}
          />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Designacoes.EditarDesignacao.tabDadosDaDesignacao.formulario.Prioridade}:</label>
          <input type="number" name="priority" className="form-control" placeholder="" value={this.state.priority} onChange={this.handleChange.bind(this, 'priority')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Designacoes.EditarDesignacao.tabDadosDaDesignacao.formulario.ChefeDeEquipamento}:</label>
          <br/>
          <Toggle
            checked={this.state.equip_chief}
            aria-label='No label tag'
            name="equip_chief"
            onChange={this.handleToggleChange.bind(this, 'equip_chief')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-12">
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Designacoes.EditarDesignacao.tabDadosDaDesignacao.formulario.botaoSalvarEdicao}</button>
      </div>
    </div>
  </form>
</div>
    );
  }
}

export default DesignationsEditTab;



// WEBPACK FOOTER //
// ./src/Components/Designations/Elements/DesignationsEditTab.js